var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PmNoRealTaskLeftTreeForResource',{ref:"PmNoRealTaskResourceTreePage",on:{"resourceTreeClickEventPush":_vm.resourceTreeClickEventPush}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }